import {createGlobalState} from 'react-use';

export const MiniCartOpenGlobalState = createGlobalState(false);
